/**
 *
 */
(function ($, Drupal) {
  // Codigo slider
  function sliderCard() {
    $(
      ".block-views-blockawards-block-2 .view-awards .view-content "
    ).slick({
      infinite: true,
      dots: true,
      dotsClass:'slick-dots-premios',
      slidesToShow: 1,
      slidesToScroll: 1,
      touchMove: true,
      speed: 500,
      arrows: true,
      focusOnSelect: true,
      // autoplay: true,
    });
  }
  function sliderproducto() {
    $(
      ".block-carnival-awards-landing-block .view-awards .view-content "
    ).slick({
      infinite: true,
      dots: true,
      dotsClass:'slick-dots-premios',
      slidesToShow: 1,
      slidesToScroll: 1,
      touchMove: true,
      speed: 500,
      arrows: true,
      focusOnSelect: true,
    });
  }
  // Codigo activacion selectores personalizados
  $('select.form-select').niceSelect();
  // Codigo estrellas seleccion
  function starinput(contenedor,inputactual){
    contenedor.forEach(element => {
      element.classList.remove("star-active-inpu");
      if (parseInt(element.value)<=inputactual) {
        element.className += " star-active-inpu";
      }
    });
  }
  function starRecovery(){
    $('input[type=radio]').on('change',function () {  
      let nombre=$(this).attr("name");
      let inputactual=$(this).val(); // or, use `this.value`
      let contenedor;
      let questions = ['two','three','four','five','six','seven'];
      if(inputactual != " " && inputactual != undefined){
        $.each(questions,function(i,val){
          $.each(['one','two','three'],function(j,sval){
            if(nombre == 'question_'+val+'_'+sval){
              contenedor =$(".webform-scale-options")[j].querySelectorAll(".form-check-input");
              starinput(contenedor,inputactual);
              return;
            };
          });    
        });
      }
    });
  }
  // Funcion de anclo desktop
  if ($("body").hasClass("page--carnival-landing--grant-verification")||
  $("body").hasClass("carnival--error-page")||
  $("body").hasClass("carnival--terms-page")||
  $("body").hasClass("path-webform")||
  $("body").hasClass("page--carnival-landing--awards")||
  $("body").hasClass("page--carnival-landing--main")){
    if($(window).width() >=1024){
      alert(
        "Pagina no disponible para computadores, porfavor ingresar en tablet o celular"
      );
    }
    $(window).resize(function () {
      if($(window).width() >= 1024 ){
        alert(
          "Pagina no disponible para computadores, porfavor ingresar en tablet o celular"
        );
      }
    });
  }
  var windowWidth = window.innerWidth;
  Drupal.behaviors.club_colombia = {
    attach: function (context) {
      sliderCard() 
      sliderproducto()
      starRecovery()
    },
  };
})(jQuery, Drupal);
